var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.25C10.875 8.28552 10.0355 9.125 9 9.125C7.96448 9.125 7.125 8.28552 7.125 7.25C7.125 6.21447 7.96448 5.375 9 5.375C10.0355 5.375 10.875 6.21447 10.875 7.25Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.25C10.875 8.28552 10.0355 9.125 9 9.125C7.96448 9.125 7.125 8.28552 7.125 7.25C7.125 6.21447 7.96448 5.375 9 5.375C10.0355 5.375 10.875 6.21447 10.875 7.25Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.25C10.875 8.28552 10.0355 9.125 9 9.125C7.96448 9.125 7.125 8.28552 7.125 7.25C7.125 6.21447 7.96448 5.375 9 5.375C10.0355 5.375 10.875 6.21447 10.875 7.25Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.25C10.875 8.28552 10.0355 9.125 9 9.125C7.96448 9.125 7.125 8.28552 7.125 7.25C7.125 6.21447 7.96448 5.375 9 5.375C10.0355 5.375 10.875 6.21447 10.875 7.25Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 13.25C14.7125 14.7414 15.2128 15.5356 14.9149 16.1749C14.8849 16.2391 14.8499 16.3009 14.8102 16.36C14.3793 17 13.2656 17 11.0383 17H6.96167C4.73438 17 3.62074 17 3.18983 16.36C3.15004 16.3009 3.11504 16.2391 3.08516 16.1749C2.78714 15.5356 3.28744 14.7414 4.33333 13.25",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 13.25C14.7125 14.7414 15.2128 15.5356 14.9149 16.1749C14.8849 16.2391 14.8499 16.3009 14.8102 16.36C14.3793 17 13.2656 17 11.0383 17H6.96167C4.73438 17 3.62074 17 3.18983 16.36C3.15004 16.3009 3.11504 16.2391 3.08516 16.1749C2.78714 15.5356 3.28744 14.7414 4.33333 13.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 13.25C14.7125 14.7414 15.2128 15.5356 14.9149 16.1749C14.8849 16.2391 14.8499 16.3009 14.8102 16.36C14.3793 17 13.2656 17 11.0383 17H6.96167C4.73438 17 3.62074 17 3.18983 16.36C3.15004 16.3009 3.11504 16.2391 3.08516 16.1749C2.78714 15.5356 3.28744 14.7414 4.33333 13.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 13.25C14.7125 14.7414 15.2128 15.5356 14.9149 16.1749C14.8849 16.2391 14.8499 16.3009 14.8102 16.36C14.3793 17 13.2656 17 11.0383 17H6.96167C4.73438 17 3.62074 17 3.18983 16.36C3.15004 16.3009 3.11504 16.2391 3.08516 16.1749C2.78714 15.5356 3.28744 14.7414 4.33333 13.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94305 13.6202C9.69007 13.8638 9.35198 14 9.00015 14C8.64825 14 8.31015 13.8638 8.05717 13.6202C5.74072 11.3756 2.63639 8.86812 4.15028 5.2278C4.96882 3.25949 6.93371 2 9.00015 2C11.0666 2 13.0314 3.2595 13.85 5.2278C15.362 8.86355 12.2652 11.3833 9.94305 13.6202Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94305 13.6202C9.69007 13.8638 9.35198 14 9.00015 14C8.64825 14 8.31015 13.8638 8.05717 13.6202C5.74072 11.3756 2.63639 8.86812 4.15028 5.2278C4.96882 3.25949 6.93371 2 9.00015 2C11.0666 2 13.0314 3.2595 13.85 5.2278C15.362 8.86355 12.2652 11.3833 9.94305 13.6202Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94305 13.6202C9.69007 13.8638 9.35198 14 9.00015 14C8.64825 14 8.31015 13.8638 8.05717 13.6202C5.74072 11.3756 2.63639 8.86812 4.15028 5.2278C4.96882 3.25949 6.93371 2 9.00015 2C11.0666 2 13.0314 3.2595 13.85 5.2278C15.362 8.86355 12.2652 11.3833 9.94305 13.6202Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94305 13.6202C9.69007 13.8638 9.35198 14 9.00015 14C8.64825 14 8.31015 13.8638 8.05717 13.6202C5.74072 11.3756 2.63639 8.86812 4.15028 5.2278C4.96882 3.25949 6.93371 2 9.00015 2C11.0666 2 13.0314 3.2595 13.85 5.2278C15.362 8.86355 12.2652 11.3833 9.94305 13.6202Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.aa40fa0fe251b5de56f67ce0175feab2.svg";
export { ForwardRef as ReactComponent };